export default {
  getBeaconById: (state) => (inputValue) => {
    return state.beacons.filter(beacon => {
      var locationNameResult = null
      var uuidResult = null
      if (beacon.locationName !== null) {
        locationNameResult = beacon.locationName.match(inputValue)
      }
      if (beacon.uuid !== null) {
        uuidResult = beacon.uuid.match(inputValue)
      }
      if (locationNameResult !== null || uuidResult !== null) {
        var result = beacon.locationName + beacon.uuid
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/beaconModules/getters.js